import { render, staticRenderFns } from "./RegistrarAsignacionItems.vue?vue&type=template&id=8656f0a8&scoped=true&"
import script from "./RegistrarAsignacionItems.vue?vue&type=script&lang=js&"
export * from "./RegistrarAsignacionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8656f0a8",
  null
  
)

export default component.exports